import uniqueId from 'lodash/uniqueId';

const Product = (productData = {}) => {
	const {
		Active = true,
		CategoryId = null,
		CreateDate = '',
		CustomsCountry = '',
		CustomsDescription = '',
		CustomsTariffNo = '',
		CustomsValue = 0,
		Height = 0,
		InternalNotes = '',
		Length = 0,
		ModifyDate = '',
		Name = '',
		NoCustoms = null,
		ProductAliases = [],
		ProductID = null,
		SKU = '',
		Tags = [],
		ThumbnailUrl = '',
		UPC = '',
		UseProductName = false,
		WarehouseLocation = '',
		Weight = 0,
		Width = 0,
	} = productData;

	return {
		Active,
		CategoryId,
		CreateDate: CreateDate && CreateDate !== '' ? new Date(CreateDate) : null,
		CustomsCountry,
		CustomsDescription,
		CustomsTariffNo,
		CustomsValue,
		Height,
		InternalNotes,
		Length,
		ModifyDate: ModifyDate && ModifyDate !== '' ? new Date(ModifyDate) : null,
		Name,
		NoCustoms,
		ProductAliases: ProductAliases.map(alias => ({
			...alias,
			id: uniqueId(),
		})),
		ProductTags: Tags.map(tag => ({ ProductID, OrderTagID: tag })),
		ProductID,
		SKU,
		Tags,
		ThumbnailUrl,
		UPC,
		UseProductName: UseProductName === true,
		WarehouseLocation,
		WeightUnitOfMeasureID: 1,
		Weight,
		WeightOz: null,
		Width,
	};
};

export default Product;
